(function ($) {
    'use strict';
    var $emailButton =  $('.js-button-email'),
        $printButton = $('.js-button-print');

        if ($emailButton.length) {
            var emailCurrentPage = $emailButton.on("click", function () {
                window.location.href = "mailto:?subject=" + document.title + "&body=" + escape(window.location.href);
            });
        }

        if ($printButton.length) {
            var printCurrentPage = $printButton.on("click", function () {
                window.print();
                return false;
            });

        }
  
}(jQuery));